export default __webpack_public_path__ + "static/media/hand_phone_sm_ro.15caf2c9.png";